import React, { createContext, useEffect, useState } from 'react'

import { api, authHeaders } from '../services/api'
import { descriptografar } from '../util/crypto'

import logo from '../assets/images/zelai horizontal.png'
import logoSquare from '../assets/images/zelai.png'

export const GlobalContext = createContext()

const GlobalProvider = ({ children }) => {
    const [user, setUser] = useState(null)
    const [clienteRobot, setClienteRobot] = useState(null)
    const [isDadosVisiveis, setIsDadosVisiveis] = useState(true)

    // Instalação app
    const [promptInstalacaoApp, setPromptInstalacaoApp] = useState(null)
    const [showButtonInstacaoApp, setShowButtonInstacaoApp] = useState(false)

    async function loadRobotCliente() {
        const customer = {
            name: 'ZelAI',
            logo,
            logo_square: logoSquare,
            inicio_numeracao_boleto: '0000',
            cnpj: '00.000.000/0000-00',
            footer_content: {
                endereco: 'Avenida Xyz, 123 - Nazaré – Belém – Pará',
                copyright: 'ZelAI',
                links: [
                    {
                        href: '#',
                        label: 'Política de Privacidade',
                    },
                    {
                        href: '#',
                        label: 'Termos de Uso'
                    }
                ],
                contatos: [
                    '(11) 94762-9373',
                    'comercial@solucaojundiai.com.br'
                ]
            }
        }

        setClienteRobot(customer)
    }

    function checkRecurso(recurso) {
        if(user) {
            return !!user.recursos?.includes(recurso)
        }

        return false
    }

    function disableInstalacaoApp() {
        setPromptInstalacaoApp(null)
        setShowButtonInstacaoApp(false)
    }

    async function handleInstalarApp() {
        if (!promptInstalacaoApp) {
            return
        }

        promptInstalacaoApp.prompt()

        const { outcome } = await promptInstalacaoApp.userChoice

        if (outcome === 'accepted') {
            console.log('Usuário aceitou a instalação')
        } else {
            console.log('Usuário recusou a instalação')
        }

        disableInstalacaoApp()
    }

    function alterarAssinatura({ id, data }) {
        const assinaturaAAtualizar = user.pessoa.assinaturas.find(a => a.id === id)

        const assinaturaAtualizada = Object.assign(assinaturaAAtualizar, data)

        const assinaturasRestantes = user.pessoa.assinaturas.filter(a => a.id !== id)

        setUser(old => ({
            ...old,
            pessoa: {
                ...old.pessoa,
                assinaturas: [
                    assinaturaAtualizada,
                    ...assinaturasRestantes
                ]
            }
        }))
    }

    function toggleIsDadosVisiveis() {
        setIsDadosVisiveis(old => !old)
    }

    useEffect(() => {
        loadRobotCliente()
    }, [])

    useEffect(() => {
        const storedUser = descriptografar(sessionStorage.getItem(process.env.REACT_APP_SESSION_STORAGE_USER))

        if (storedUser) {
            setUser(storedUser)
        } else {
            setUser(null)
        }
    }, [])

    useEffect(() => {
        const handleBeforeInstallPrompt = e => {
            e.preventDefault()
            
            setPromptInstalacaoApp(e)

            setShowButtonInstacaoApp(true)
        }

        window.addEventListener('beforeinstallprompt', handleBeforeInstallPrompt)
        window.addEventListener('appinstalled', disableInstalacaoApp)

        return () => {
            window.removeEventListener('beforeinstallprompt', handleBeforeInstallPrompt)
            window.removeEventListener('appinstalled', disableInstalacaoApp)
        }
    }, [])

    async function reload() {
        if (user) {
            const response = await api.get('usuario', authHeaders())

            const storedUser = descriptografar(sessionStorage.getItem(process.env.REACT_APP_SESSION_STORAGE_USER))

            setUser({
                ...storedUser,
                biometria: response.usuario_biometria,
                pessoa: {
                    ...storedUser.pessoa,
                    assinaturas: response.pessoa.assinaturas
                },
                avatar: response.avatar?.link || null
            })
        }
    }

    return (
        <GlobalContext.Provider value={{
            user,
            setUser,
            reload,
            clienteRobot,
            checkRecurso,
            handleInstalarApp,
            showButtonInstacaoApp,
            alterarAssinatura,
            isDadosVisiveis, 
            toggleIsDadosVisiveis
        }}
        >
            {clienteRobot ? children : null}
        </GlobalContext.Provider>
    )
}

export default GlobalProvider
